import React, { Component } from 'react';

export function Info() {
    return (
        <div>
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>이용안내</span></li>
                        </ol>
                        <div class="card">
                            <div class="card-body" style={{marginBottom: '10px'}}>
                                <h4 class="card-title" style={{fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>FAQ</h4>
                                <p class="card-text" style={{fontWeight: 'bold', marginTop: '10px'}}>회원가입, 로그인</p>
                                <p class="card-text">
                                <ol class="list-group list-group-numbered">
                                    <li class="list-group-item d-flex justify-content-between align-items-start">
                                        <div class="ms-2 me-auto">
                                            <div class="fw-bold">개인 회원가입</div>
                                            <ul>
                                                <li>로그인페이지 클릭</li>
                                                <li>회원가입 클릭</li>
                                                <li>회원가입약관과 개인정보처리방침 내용에 동의 체크</li>
                                                <li>개인회원 클릭</li>
                                                <li>이름(실명)과 이메일(아이디) 및 비빌번호를 입력후 가입하기 클릭</li>
                                            </ul>
                                        </div>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-start">
                                        <div class="ms-2 me-auto">
                                            <div class="fw-bold">기업 회원가입</div>
                                            <ul>
                                                <li>로그인페이지 클릭</li>
                                                <li>회원가입 클릭</li>
                                                <li>회원가입약관과 개인정보처리방침 내용에 동의 체크</li>
                                                <li>기업회원 클릭</li>
                                                <li>이메일(아이디), 회사명 및 회사주소, 대표자명 및 전화번호, 인사담당자 전화번호 및 이메일, 비빌번호를 입력후 가입하기 클릭</li>
                                                <li>사업자관련 증빙서류 이메일로 제출후에 승인요청</li>
                                            </ul>
                                        </div>
                                    </li>
                                </ol>
                                </p>
                                <p class="card-text" style={{fontWeight: 'bold', marginTop: '10px'}}>프리미엄 채용공고 등록방법</p>
                                <p class="card-text">
                                <ol class="list-group list-group-numbered">
                                    <li class="list-group-item d-flex justify-content-between align-items-start">
                                        <div class="ms-2 me-auto">
                                            <div class="fw-bold">직접 등록</div>
                                            <ul>
                                                <li>기업회원 가입 후 채용공고를 작성합니다</li>
                                                <li>해당 금액을 입금합니다</li>
                                                <li>사업체 운영을 증명할 수 있는 서류(최초), 회원아이디, 이름을 이메일로 제출합니다</li>
                                                <li>확인 후 공고 게재를 승인해 드립니다</li>
                                            </ul>
                                        </div>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-start">
                                        <div class="ms-2 me-auto">
                                            <div class="fw-bold">위임 등록</div>
                                            <ul>
                                                <li>채용공고에 필요한 정보와 사업체 운영 증빙 서류(최초)를 이메일로 제출합니다</li>
                                                <li>해당 금액을 입금합니다</li>
                                                <li>확인 후 공고 게재를 승인해 드립니다</li>
                                            </ul>
                                        </div>
                                    </li>
                                </ol>
                                </p>
                                <p class="card-text" style={{fontWeight: 'bold', marginTop: '10px'}}>일반 채용공고 등록방법</p>
                                <p class="card-text">
                                <ol class="list-group list-group-numbered">
                                    <ul>
                                        <li>기업회원 가입 후 채용공고를 작성합니다</li>
                                        <li>사업체 운영을 증명할 수 있는 서류(최초)를 이메일로 제출합니다</li>
                                        <li>확인 후 공고 게재를 승인해 드립니다</li>
                                    </ul>
                                </ol>
                                </p>
                                <p class="card-text" style={{fontWeight: 'bold', marginTop: '10px'}}>프리미엄 인재공고 등록방법</p>
                                <p class="card-text">
                                <ol class="list-group list-group-numbered">
                                    <ul>
                                        <li>개인인회원 가입 후 인재공고를 작성합니다</li>
                                        <li>해당 금액을 입금합니다</li>
                                        <li>회원아이디와 이름을 이메일로 제출합니다</li>
                                        <li>확인 후 공고 게재를 승인해 드립니다</li>
                                    </ul>
                                </ol>
                                </p>
                                <p class="card-text" style={{fontWeight: 'bold', marginTop: '10px'}}>일반 인재공고 등록방법</p>
                                <p class="card-text">
                                <ol class="list-group list-group-numbered">
                                    <ul>
                                        <li>개인인회원 가입 후 인재공고를 작성합니다</li>
                                        <li>회원아이디와 이름을 이메일로 제출합니다</li>
                                        <li>확인 후 공고 게재를 승인해 드립니다</li>
                                    </ul>
                                </ol>
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}